let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("h6lR9")).then(() => parcelRequire('cpC58'));